import React, { useState, FormEvent } from "react";
import { useMsal } from "@azure/msal-react";
import { PopupRequest } from "@azure/msal-browser";
import { loginRequest } from "../utils/AzureAuthService";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./Styles.css";
import { AUTHENTICATION_ERROR, LOGIN_ACCESS_ERROR } from "../constants/constants";

interface DecodedToken {
  roles?: string[];
  [key: string]: any;
}

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userRole, setUserRole] = useState<string | null>(null);

  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const request: PopupRequest = {
        ...loginRequest,
        loginHint: email,
      };

      const result = await instance.loginPopup(request);

      if (result?.accessToken) {

        sessionStorage.setItem("access_token", result?.accessToken);
        sessionStorage.setItem("id_token", result?.idToken);

        const decodedIdToken: DecodedToken = jwtDecode(result?.idToken);

        const userRoles = decodedIdToken?.roles || [];

        if (userRoles?.length > 0) {
          setUserRole(userRoles[0]); 
        }

        if (userRoles?.length === 0) {
          setError(LOGIN_ACCESS_ERROR);
          sessionStorage.removeItem("access_token"); 
        }
      }
    } catch (error) {
      setError(AUTHENTICATION_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="loginpage-container">
      <div className="loginpage-box">
        <h2 className="loginpage-title">AWGMENT</h2>
        {error && <div className="loginpage-error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target?.value)}
            className="loginpage-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target?.value)}
            className="loginpage-input"
          />
          <div className="loginpage-options">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRememberMe(e.target?.checked)}
              />
              Remember me
            </label>
          </div>
          <button type="submit" className="loginpage-button" disabled={isLoading}>
            {isLoading ? "Signing in..." : "Log In"}
          </button>
        </form>
        {userRole && <p className="loginpage-role">Logged in as: <strong>{userRole}</strong></p>}
      </div>
    </div>
  );
};

export default LoginPage;
